import { GroupModel } from '@/models/Group';
import { GroupStore } from '@/stores/group/store';

abstract class BaseDecideOddsStrategy {
    protected getDrawableGroups(targetGroups: GroupModel[]): GroupModel[] {
        // null除外
        targetGroups = targetGroups.filter(group => group);

        const drawableGroups: GroupModel[] = [];
        for (const group of targetGroups) {
            if (group.drawable) {
                drawableGroups.push(group);
            } else {
                group.drawOdds = 0;
            }
        }
        return drawableGroups;
    }

    public abstract decideOdds(targetGroups: GroupModel[]): void;
}

class BalancedOddsStrategy extends BaseDecideOddsStrategy {
    public decideOdds(targetGroups: GroupModel[]): void {
        const drawableGroups = this.getDrawableGroups(targetGroups);
        const drawOdds = 100 / drawableGroups.length;
        drawableGroups.map((group) => group.drawOdds = drawOdds);
    }
}

class RarityDependedOddsStrategy extends BaseDecideOddsStrategy {
    protected OddsAllocation = class  {
        public allocation!: number;

        public condition!: (group: GroupModel) => boolean;

        public constructor(allocation: number, condition: (group: GroupModel) => boolean) {
            this.allocation = allocation;
            this.condition = condition;
        }
    }

    public decideOdds(targetGroups: GroupModel[]): void {
        const oddsAllocations = [
            new this.OddsAllocation(1, (group: GroupModel) => {
                const maxRarity = group.operators.reduce((a, b) => a.rarity > b.rarity ? a:b).rarity;
                if (maxRarity === 6) {
                    return true;
                }
                return false;
            }),
            new this.OddsAllocation(2, (group: GroupModel) => {
                const maxRarity = group.operators.reduce((a, b) => a.rarity > b.rarity ? a:b).rarity;
                if (maxRarity < 6) {
                    return true;
                }
                return false;
            }),
        ];
        const drawableGroups = this.getDrawableGroups(targetGroups);
        let weightedGroupSum: number = 0;
        drawableGroups.map((group) => {
            const targetOddsAllocation = oddsAllocations.find((oddsAllocation) => oddsAllocation.condition(group));
            weightedGroupSum += targetOddsAllocation ? targetOddsAllocation.allocation : 0;
        });
        const oddsUnit = 100 / weightedGroupSum;
        drawableGroups.map((group) => {
            const targetOddsAllocation = oddsAllocations.find((oddsAllocation) => oddsAllocation.condition(group));
            group.drawOdds = targetOddsAllocation ? oddsUnit * targetOddsAllocation.allocation : oddsUnit;
        });
    }
}

export { BaseDecideOddsStrategy, BalancedOddsStrategy, RarityDependedOddsStrategy };
